import { useLocale } from '@/i18n';
import { HELPLINES_PDF } from '@/content/company';
import { cx } from '@/components/ui/cx';

const tel = (href: string, label: string, className: string) => (
  <a href={href} className={className}>
    {label}
  </a>
);

/**
 * ZenQuip's site-wide safety disclaimer, word for word (EN approved; HI as on zenquip.com's Hindi
 * pages). Numbers are `tel:` links so a tap dials on a phone. `tone="dark"` for the footer.
 */
export const CrisisNote = ({ tone = 'light', className }: { tone?: 'light' | 'dark'; className?: string }) => {
  const { locale } = useLocale();
  const link = tone === 'dark' ? 'font-bold text-white underline-offset-2 hover:underline' : 'font-bold text-lagoon-700 underline-offset-2 hover:underline';
  const hi = locale === 'hi';
  return (
    <div className={cx('text-caption font-semibold leading-relaxed', className)}>
      {hi ? (
        <p>
          ZenQuip एक मानसिक स्वास्थ्य सहायता मंच है। यह चिकित्सकीय निदान नहीं देता और किसी योग्य पेशेवर द्वारा जाँच या इलाज का विकल्प नहीं है। अगर आप संकट में हैं, तो{' '}
          {tel('tel:14416', 'Tele-MANAS 14416', link)} (या {tel('tel:18008914416', '1-800-891-4416', link)}),{' '}
          {tel('tel:18005990019', 'KIRAN 1800-599-0019', link)}, या {tel('tel:+919999666555', 'Vandrevala Foundation +91 9999 666 555', link)} (भारत) पर कॉल करें, या तुरंत अपनी स्थानीय आपातकालीन सेवाओं से संपर्क करें।
        </p>
      ) : (
        <p>
          ZenQuip is a mental health support platform. It does not provide medical diagnoses and is not a substitute for evaluation or treatment by a qualified professional. If you are in crisis, call{' '}
          {tel('tel:14416', 'Tele-MANAS 14416', link)} (or {tel('tel:18008914416', '1-800-891-4416', link)}) or {tel('tel:18005990019', 'KIRAN 1800-599-0019', link)} or{' '}
          {tel('tel:+919999666555', 'Vandrevala Foundation +91 9999 666 555', link)} (India), or contact your local emergency services immediately.
        </p>
      )}
      <p className="mt-2">
        <a href={HELPLINES_PDF} target="_blank" rel="noopener noreferrer" className={cx(link, 'underline')}>
          {hi ? 'हमारी संकट हेल्पलाइन सूची देखें (PDF)' : 'View our crisis helplines reference (PDF)'}
        </a>
      </p>
    </div>
  );
};
